import CardsList from "@/components/cardsList";
import {ONEMIND_LAAS_CONSTANTS} from "./constants";
import {Text, Stack} from "@chakra-ui/react";
import {useTextVariants} from "@/theme/components/useSectionHeading";

const WhyChooseComponent = () => {
  const TextVariant = useTextVariants();
  return (
    <Stack spacing={6} align={"center"}>
      <CardsList
        columns={{base: 1, sm: 2, md: 4}}
        title={ONEMIND_LAAS_CONSTANTS.title}
        list={ONEMIND_LAAS_CONSTANTS.list}
        spacing={{base: 8, md: 16}}
        hoverEffect
      />
      <Text variant={TextVariant} color="text.100">
        {ONEMIND_LAAS_CONSTANTS.conclusion}
      </Text>
    </Stack>
  );
};

export default WhyChooseComponent;
